import {
    BatchEfakturaApprovalResult,
    type BatchEfakturaItemSigningResult,
    type DynamicLinkId,
    EfakturaBatchPaymentRequest,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, post } from './request';

const SERVICE_PATH = `${CONTEXT_PATH}/rest/resource/efaktura/batch`;

export const payBatchEFaktura = (efakturaBatchRequest: EfakturaBatchPaymentRequest) => {
    return post<BatchEfakturaApprovalResult>(SERVICE_PATH, efakturaBatchRequest);
};

export const getBatchedEfakturaSigningResult = (
    dynamicLinkId: DynamicLinkId,
): Promise<BatchEfakturaItemSigningResult[]> => get(`${SERVICE_PATH}/${dynamicLinkId.value}`);
